export const DEFAULT_PAGE = 0;
export const DEFAULT_ROWS_PER_PAGE = 10;

export const DEFAULT_FILTERS = {
  searchBar: "",
  status: null,
  descendingCreationDateSort: null,
};

export const ORDER_FILTERS = {
  searchBar: "",
  status: null,
  fromDate: null,
  toDate: null,
  senderName: "",
  orderNumber: null,
  receiverName: "",
  driverName: "",
  sortDescending: true,
  pickupDate: null,
  dropoffDate: null,
  creationDate: null,
};
